export enum AutoScalingActions {
    Create,
    Update,
    Delete
}
